import React from 'react';
import { SkeletonLoader } from '../ui/LoadingSpinner';

function UserListSkeleton() {
  return (
    <div className="p-6">
      {/* Loading indicator */}
      <div className="flex items-center justify-center mb-8 p-4 bg-fresh-leaf/5 border-l-4 border-fresh-leaf">
        <div className="loading-spinner w-5 h-5 mr-3"></div>
        <span className="text-forest-fern font-medium text-sm uppercase tracking-wide">Loading users</span>
      </div>
      
      {/* Header skeleton */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6 mb-8">
        <SkeletonLoader className="w-32 h-12 loading-skeleton" />
        <SkeletonLoader className="w-80 h-12 loading-skeleton" />
      </div>
      
      {/* Filters skeleton */}
      <div className="flex flex-col sm:flex-row gap-4 mb-8">
        <SkeletonLoader className="w-32 h-12 loading-skeleton" />
        <SkeletonLoader className="w-32 h-12 loading-skeleton" />
      </div>
      
      {/* Count skeleton */}
      <div className="mb-6">
        <SkeletonLoader className="w-48 h-5 loading-skeleton" />
      </div>
      
      {/* Table skeleton */}
      <div className="card overflow-hidden">
        {/* Table header */}
        <div className="card-header">
          <div className="flex justify-between items-center">
            <SkeletonLoader className="w-16 h-4 bg-crystal-white/20" />
            <SkeletonLoader className="w-16 h-4 bg-crystal-white/20" />
            <SkeletonLoader className="w-16 h-4 bg-crystal-white/20" />
            <SkeletonLoader className="w-20 h-4 bg-crystal-white/20" />
            <SkeletonLoader className="w-16 h-4 bg-crystal-white/20" />
          </div>
        </div>
        
        {/* Table rows skeleton */}
        <div className="bg-crystal-white divide-y divide-silver-mist">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="px-6 py-6 hover:bg-silver-mist/50 transition-colors duration-200">
              <div className="flex items-center justify-between">
                {/* User info column */}
                <div className="flex items-center flex-1">
                  <SkeletonLoader className="h-12 w-12 loading-skeleton" />
                  <div className="ml-4 flex-1">
                    <SkeletonLoader className="w-32 h-4 loading-skeleton mb-2" />
                    <SkeletonLoader className="w-40 h-3 loading-skeleton" />
                  </div>
                </div>
                
                {/* Status column */}
                <div className="flex-shrink-0 px-4">
                  <SkeletonLoader className="w-20 h-6 loading-skeleton" />
                </div>
                
                {/* Roles column */}
                <div className="flex-shrink-0 px-4">
                  <div className="flex flex-wrap gap-2">
                    <SkeletonLoader className="w-16 h-6 loading-skeleton" />
                    <SkeletonLoader className="w-20 h-6 loading-skeleton" />
                  </div>
                </div>
                
                {/* Last login column */}
                <div className="flex-shrink-0 px-4">
                  <SkeletonLoader className="w-24 h-4 loading-skeleton" />
                </div>
                
                {/* Actions column */}
                <div className="flex-shrink-0">
                  <div className="flex space-x-3">
                    <SkeletonLoader className="w-8 h-4 loading-skeleton" />
                    <SkeletonLoader className="w-12 h-4 loading-skeleton" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Pagination skeleton */}
      <div className="mt-8 flex items-center justify-between">
        <SkeletonLoader className="w-32 h-4 loading-skeleton" />
        <div className="flex space-x-2">
          <SkeletonLoader className="w-8 h-8 loading-skeleton" />
          <SkeletonLoader className="w-8 h-8 loading-skeleton" />
          <SkeletonLoader className="w-8 h-8 loading-skeleton" />
          <SkeletonLoader className="w-8 h-8 loading-skeleton" />
        </div>
      </div>
      
      {/* Footer message */}
      <div className="mt-8 text-center">
        <p className="text-sm text-steel font-medium">Fetching user data from server...</p>
        <div className="mt-2 flex justify-center">
          <div className="w-32 h-1 bg-silver-mist">
            <div className="h-full bg-fresh-leaf animate-pulse-slow"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserListSkeleton;
